/*
 * @message:
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-06-30 16:07:07
 * @FilePath: \mrc-ess-fronted\src\util\common.js
 * @最后编辑: Betway
 * @最后修改时间: 2022-04-18 14:38:33
 */
import {
  toPage,
  logZ,
  GetRules,
  showMessage,
  tableSetting,
  selectSetting,
  getUtcTime,
  oneColors,
  getCommonLangKey,
  getTimeValue,
  throttle,
  fliterValue,
  getTagColors,
  defaultInitValue,
  getDateTime,
  Sleep,
  pushHistory,
  transCommonLangKey,
  transOnLineCommonLangKey,
  get_thousand_num,
  getCommonLangValue,
  staffFilter,
  getSelectTrans,
  iSJson,
  Colors,
  avatarColors,
  timeMachine,
  sortList,
  chunkArr,
  byteconvert,
  isEqualInitValue,
  getAvatar,
  getUtcByCode,
  confirmDo,
  confirmWarn,
  loginEncrypt,
  aesEncrypt,
  aesDecrypt,
  translateDataToTree,
  hideMessage,
  UniqueArry,
  getStaff,
  toggleFullScreen,
  toBack,
} from "@/util/func";
import Vue from "vue";
import messaging from "@/util/firebase";
import { Request, api, findPrompt } from "@/api/api";
import "@/util/components"; // 引入全局组件
//自定义svg icon
import "@/assets/icons";
//自定義hover樣式,暂时废弃
// import "hover.css";
// 图片上传
import VueAzureUploader from "vue-azure-blob-upload";
Vue.use(VueAzureUploader);
//全局加载
import NProgress from "@/util/progress";
// 全局Color
Vue.prototype.$Colors = Colors;
Vue.prototype.$avatarColors = avatarColors;
Vue.prototype.$oneColors = oneColors;
Vue.prototype.$getTagColors = getTagColors;
// Colors_排版格子底线颜色
Vue.prototype.$card_line_colors = [];
//全屏
Vue.prototype.$toggleFullScreen = toggleFullScreen;
//全局加载
Vue.prototype.$NProgress = NProgress;
//全局跳转方法
Vue.prototype.$toPage = toPage;
//全局table配置
Vue.prototype.$tableSetting = tableSetting;
//全局select
Vue.prototype.$selectSetting = selectSetting;
//传送日志
Vue.prototype.$logZ = logZ;
//接收消息
Vue.prototype.$messaging = messaging;
//全局from rules
Vue.prototype.$GetRules = GetRules;
//消息提示框
Vue.prototype.$showMessage = showMessage;
Vue.prototype.$hideMessage = hideMessage;
//全局请求
Vue.prototype.$Request = Request;
Vue.prototype.$findPrompt = findPrompt;
Vue.prototype.$Api = [];
//全局時間转换
Vue.prototype.$timeMachine = timeMachine;
//全局UTC时间转换
Vue.prototype.$getUtcTime = getUtcTime;
//获取时区字符
Vue.prototype.$getUtcByCode = getUtcByCode;
//数组去重
Vue.prototype.$UniqueArry = UniqueArry;
// 全局列表排序
Vue.prototype.$sortList = sortList;
//节流
Vue.prototype.$throttle = throttle;

//全局语言key
Vue.prototype.$getCommonLangKey = getCommonLangKey;
Vue.prototype.$transCommonLangKey = transCommonLangKey;
Vue.prototype.$getCommonLangValue = getCommonLangValue;
Vue.prototype.$transOnLineCommonLangKey = transOnLineCommonLangKey;
Vue.prototype.$getSelectTrans = getSelectTrans;
// 时间错
Vue.prototype.$getTimeValue = getTimeValue;
Vue.prototype.$getDateTime = getDateTime;
// 金额千分位显示
Vue.prototype.$get_thousand_num = get_thousand_num;
//全局返回
Vue.prototype.$toBack = toBack;
//书结构转换
Vue.prototype.$translateDataToTree = translateDataToTree;
//数组分组
Vue.prototype.$chunkArr = chunkArr;
// 全局错误警告弹窗
Vue.prototype.$confirmDo = confirmDo;
Vue.prototype.$confirmWarn = confirmWarn;
// 头像获取
Vue.prototype.$getAvatar = getAvatar;
//
Vue.prototype.$pushHistory = pushHistory;
// 筛选赋值
Vue.prototype.$fliterValue = fliterValue;
// 获取树形结构的员工
Vue.prototype.$getStaff = getStaff;
//延迟
Vue.prototype.$Sleep = Sleep;
// 全局加密/解密
Vue.prototype.$aesEncrypt = aesEncrypt;
Vue.prototype.$aesDecrypt = aesDecrypt;
Vue.prototype.$loginEncrypt = loginEncrypt;
//  筛选员工
Vue.prototype.$staffFilter = staffFilter;
//文件大小转换
Vue.prototype.$byteconvert = byteconvert;
//初始化默认值
Vue.prototype.$defaultInitValue = defaultInitValue;
Vue.prototype.$isEqualInitValue = isEqualInitValue;
//Json验证
Vue.prototype.$iSJson = iSJson;

//在此统一获取所有员工
/*
base 通过底层接口获取
only_staff 只需要员工列表
*/
Vue.prototype.$getStaffList = (
  data,
  base = false,
  only_staff = true,
  client = false
) => {
  if (base) {
    //获取底层包含组织结构的tree结构员工数据
    return new Promise((reselve, reject) => {
      Request({
        method: "POST",
        table: "mrbase_sys_staffs",
        url: "/staff-manager/list_company_staffs/",
        data: data,
        type: "lang",
        global: false,
      })
        .then((res) => {
          if (only_staff) reselve(getStaff(res.data));
          else {
            reselve(res.data);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  } else {
    //获取不包含组织架构的所有员工列表数据
    return new Promise((reselve, reject) => {
      Request({
        method: "POST",
        table: "mrbase_sys_staffs",
        url: "/staff/list-staffs/",
        data: data,
        type: "",
        global: false,
      })
        .then((res) => {
          reselve(res.data ? res.data : []);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
};
// google地图
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAmecKo08DAjFqZVf_g1z9rTJ0Zh2k6BI0", //test:AIzaSyDf43lPdwlF98RCBsJOFNKOkoEjkwxb5Sc//prod:AIzaSyAmecKo08DAjFqZVf_g1z9rTJ0Zh2k6BI0
    libraries: "places", // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
});
